import React from "react";

const AnswerText = ({ value }) => {
  if (value === null || value === undefined || value === "") {
    return <p className="text-sm italic text-gray-400">No response</p>;
  }
  return (
    <p className="text-sm text-gray-900 bg-gray-50 border border-gray-200 rounded p-2 whitespace-pre-wrap break-words">
      {value}
    </p>
  );
};

export default AnswerText;
